module.exports = __webpack_public_path__ + "static/media/home.a9a01133.png";